module.exports = __webpack_public_path__ + "static/media/bg_1.b0dd41e6.jpg";